// Каталог витрины: разделы и товары (docs/04-api-contract.md §3, docs/07-miniapp-ux.md §2.2-2.3).
import type { ApiResponse } from "@shopkit/shared";

import { apiRequest } from "./client";

export type CategoryList = ApiResponse<"listShopCategories">;
export type Category = CategoryList["items"][number];
export type ProductList = ApiResponse<"listShopProducts">;
export type ProductSummary = ProductList["items"][number];
export type ProductDetail = ApiResponse<"getShopProduct">;

/** getCategories — видимые разделы витрины по возрастанию позиции. Бросает ApiError. */
export function getCategories(signal?: AbortSignal): Promise<CategoryList> {
  return apiRequest<CategoryList>("/api/v1/categories", { signal });
}

export interface GetProductsParams {
  categoryId?: string;
  search?: string;
  cursor?: string | null;
  limit?: number;
}

/**
 * getProducts — страница товаров каталога с курсорной пагинацией. Необязательные
 * параметры в query не попадают, если не заданы. Бросает ApiError.
 */
export function getProducts(params: GetProductsParams, signal?: AbortSignal): Promise<ProductList> {
  const query = new URLSearchParams();
  if (params.categoryId) query.set("category_id", params.categoryId);
  if (params.search) query.set("q", params.search);
  if (params.cursor) query.set("cursor", params.cursor);
  if (params.limit) query.set("limit", String(params.limit));

  const queryString = query.toString();
  return apiRequest<ProductList>(`/api/v1/products${queryString ? `?${queryString}` : ""}`, { signal });
}

/** getProduct — карточка товара витрины. 404 — товар удалён, скрыт или чужого магазина. */
export function getProduct(id: string, signal?: AbortSignal): Promise<ProductDetail> {
  return apiRequest<ProductDetail>(`/api/v1/products/${id}`, { signal });
}
